import { ATTANDANCE_OPEN, ATTANDANCE_CLOSE } from './attendanceType';

export const initialState = JSON.parse(
  localStorage.getItem('attandanceState')
) || {
  isOpen: false,
};

const attendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ATTANDANCE_OPEN:
      const openState = {
        ...state,
        isOpen: true,
      };
      localStorage.setItem('attandanceState', JSON.stringify(openState));
      return openState;

    case ATTANDANCE_CLOSE:
      const closeState = {
        ...state,
        isOpen: false,
      };
      localStorage.setItem('attandanceState', JSON.stringify(closeState));
      return closeState;

    default:
      return state;
  }
};

export default attendanceReducer;
